import MethodBuilder from "../method-builder";

type Category = "0" | "1" | "2" | "3" | "4" | "5";

type BonusBoostReward = {
  bonusBoost: number;
  depositCount: number;
  maxDepositPeriod: number | null;
};
type CreditReward = {
  amount: number;
};
type FortuneWheelReward = {
  spins: number;
};

export enum RewardType {
  Credit = "credit",
  FortuneWheel = "fortune_wheel",
  BonusBoost = "bonus_boost",
}

type TSequenceSettings = {
  sequence: number;
  reward: BonusBoostReward | CreditReward | FortuneWheelReward;
  rewardType: RewardType;
  isActive: boolean;
};

type TDailyLoginReward = {
  isActive: boolean;
  cooldown: number; // in seconds;
  sequenceSettings: Record<Category, TSequenceSettings[]>;
};

export class DailyLoginRewardAPI {
  static get = new MethodBuilder<{ hallId: number }, TDailyLoginReward | null>()
    .withName("DailyLoginReward.get")
    .build();

  static update = new MethodBuilder<
    {
      hallId: number;
      isActive: boolean;
      sequenceSettings: Record<Category, TSequenceSettings[] | undefined>;
      cooldown: number; // in seconds
    },
    void
  >()
    .withName("DailyLoginReward.update")
    .build();
}
